import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyQuestionOption } from '../teacher-feedback-service/survey-question-option';
import { LegacyTeacherFeedbackService } from '../teacher-feedback-service/legacy-teacher-feedback.service';
import { RatingAndSurveyQuestions } from '../teacher-feedback-service/rating-and-survey-questions';
import { FeedbackRateType } from '../teacher-feedback-rate/feedback-rate-types';

@Component({
  selector: 'lp2-teacher-feedback-survey-modal',
  templateUrl: './teacher-feedback-survey-modal.component.html',
  styleUrls: ['./teacher-feedback-survey-modal.component.scss'],
})
export class TeacherFeedbackSurveyModalComponent {
  responseId: number;
  questions: RatingAndSurveyQuestions = null;
  isSubmitEnabled = false;
  isLoadingData = false;
  isErrorDisplayed = false;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private legacyTeacherFeedbackService: LegacyTeacherFeedbackService,
  ) {
    this.getQuestionOptions();
  }

  getQuestionOptions() {
    this.isLoadingData = true;
    this.legacyTeacherFeedbackService.getRatingAndSurveyQuestions().subscribe(
        (response: RatingAndSurveyQuestions) => {
        this.isLoadingData = false;
        this.questions = response;
        const sadOption = this.questions.ratingQuestion.options.find(
          o => FeedbackRateType[o.questionOption.toUpperCase()] === FeedbackRateType.SAD,
        );
        sadOption.selected = true;
      },
      error => {
        this.informErrorOnLoad();
      },
    );
  }

  selectOption(option: SurveyQuestionOption) {
    option.selected = !option.selected;
    if (this.questions.surveyQuestion.options.find(o => o.selected)) {
      this.isSubmitEnabled = true;
    } else {
      this.isSubmitEnabled = false;
    }
  }

  saveQuestionOptions() {
    this.legacyTeacherFeedbackService
      .saveFeedbackSurvey(this.responseId, [this.questions.ratingQuestion, this.questions.surveyQuestion])
      .subscribe(() => {});
    this.close();
  }

  close() {
    this.ngbActiveModal.close();
  }

  informErrorOnLoad() {
    this.isSubmitEnabled = false;
    this.isLoadingData = false;
    this.isErrorDisplayed = true;
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-survey-modal/teacher-feedback-survey-modal.component.ts